import React, {useState, useEffect} from 'react'
import "./Header.scss"
import { motion } from 'framer-motion';

export const Header = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [isHeaderSticky, setisHeaderSticky] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };
    
    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    useEffect(() => {
        const handleScroll = () => {
          const scrollThreshold = 10;
          setisHeaderSticky(window.scrollY > scrollThreshold);
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);


    return (
    <div className={`header flex ${isHeaderSticky ? 'sticky-header' : ''}`}>
        <div className="header-container">
            <div className="logo-container">
            <motion.img
                src={isHovered ? '/assets/logo-2.png' : '/assets/logo-1.png'}
                alt=""
                className="logo"
                initial={{ x: -100, rotate: 0, opacity: 0 }}
                animate={{ x: 0, rotate: 360, opacity: 1}}
                transition={{ duration: 0.5, ease: 'easeOut' }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            />
            </div>
        </div>
    </div>
    )
}